import { render, staticRenderFns } from "./CardLeadStatus.vue?vue&type=template&id=1a6faf82&scoped=true&"
import script from "./CardLeadStatus.vue?vue&type=script&lang=js&"
export * from "./CardLeadStatus.vue?vue&type=script&lang=js&"
import style0 from "./CardLeadStatus.vue?vue&type=style&index=0&id=1a6faf82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6faf82",
  null
  
)

export default component.exports